/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  PlantDeviceInput,
  CertifiedPlantType,
} from '..';
import {
  serializePlantDeviceInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface UpdateDeviceInCertifiedPlantInput {
  plantId: string;
  device: PlantDeviceInput;
  tagValue?: string;
}
const build = (_query: DocumentNode, input: UpdateDeviceInCertifiedPlantInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.plantId !== undefined ? `$plantId: String = ${JSON.stringify(input.plantId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.device !== undefined ? `$device: PlantDeviceInput = ${serializePlantDeviceInput(input.device)}, ` : '' ) + ``+
    ( input.tagValue !== undefined ? `$tagValue: String = ${JSON.stringify(input.tagValue).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    updateDeviceInCertifiedPlant(
      ${ input.plantId !== undefined ? 'plantId: $plantId,' : '' } 
      ${ input.device !== undefined ? 'device: $device,' : '' } 
      ${ input.tagValue !== undefined ? 'tagValue: $tagValue,' : '' }
    ){
      ...certifiedplanttype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class UpdateDeviceInCertifiedPlantMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment certifiedplanttype on CertifiedPlantType { ... }
   */
  async execute(_query: DocumentNode, input: UpdateDeviceInCertifiedPlantInput): Promise<apollo.FetchResult< { updateDeviceInCertifiedPlant: Partial<CertifiedPlantType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ updateDeviceInCertifiedPlant: Partial<CertifiedPlantType> }>({ mutation: build(_query, input) });
  }
}
